import { PlainMessage } from '@bufbuild/protobuf';
import { GetBillOfMaterialsRequest } from '@wavingroup/aqora-v2-api/wavin/aqora/v2/aqora_service_pb';
import { aqoraClient } from '~/services/api/aqora-client';
import { authService } from '~/services/auth/auth-service';
import { TRANSPORT_URL } from '~/services/environment/environment';

export const getBOM = ({
  systemName,
  cuttingLoss,
  screwInserts,
  connectorToolAquacell160,
}: PlainMessage<GetBillOfMaterialsRequest>) =>
  aqoraClient.getBillOfMaterials({
    systemName,
    cuttingLoss: cuttingLoss / 100,
    screwInserts,
    connectorToolAquacell160,
  });

function getFilenameFromContentDisposition(contentDisposition: string | null) {
  if (!contentDisposition) return null;
  const match = contentDisposition.match(
    /filename\*?=['"]?(?:UTF-8['"]*)?([^;\r\n"]+)/i,
  );
  return match ? decodeURIComponent(match[1]) : null;
}

type GetBOMExcelRequest = {
  system_name: string;
  cutting_loss: number;
  screw_inserts: boolean;
  connector_tool_aquacell_160: boolean;
};

export const downloadBomFile = async ({
  systemName,
  cuttingLoss,
  screwInserts,
  connectorToolAquacell160,
}: {
  systemName: string;
  cuttingLoss: number;
  screwInserts: boolean;
  connectorToolAquacell160: boolean;
}): Promise<{
  data: Blob;
  filename: string | null;
}> => {
  const token = await authService.getIdentityToken();

  const requestBody = {
    system_name: systemName,
    cutting_loss: cuttingLoss / 100,
    screw_inserts: screwInserts,
    connector_tool_aquacell_160: connectorToolAquacell160,
  } satisfies GetBOMExcelRequest;

  const response = await fetch(`${TRANSPORT_URL}/download/bom-export`, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    throw new Error('Error while downloading BOM file');
  }

  const blob = await response.blob();
  const contentDisposition = response.headers.get('Content-Disposition');

  const filename = getFilenameFromContentDisposition(contentDisposition);

  return {
    data: blob,
    filename,
  };
};
